module.exports = __webpack_public_path__ + "assets/apotheke-panorama.96b8279d.png";